import React from 'react';
import { ErrorMessage, Field } from 'formik';
import PhoneFieldWithCountryFlag from './Includes/PhoneFieldWithCountryFlag';
import SimpleDonationCard from './SimpleDonationCard';

const DonatePaymentDetails = ({ index, heading, showAmount, values }) => {
  return (
    <fieldset className="form-step">
      <div className="form-step__header form-step__header--step1">
        {
          (index) => (
            <div className="form-step-header__number">{index}</div>
          )
        }
        <div className="form-step-header__title">{heading}</div>
      </div>
      <ul className="form-fields">
        <li className="form-field form-field-checkbox">
          <label htmlFor="">How would you like to pay?</label>

          <div className="checkbox">
            <ul className="form-fields form-field-checkbox-group">
              <li className="form-field checkbox-item js-direct-credit">
                <Field
                  id="payment-directDebit"
                  type="radio"
                  name="paymentMethod"
                  required="required"
                  value="directDebit"
                  onClick={(event) => {
                    document.getElementById('js-card-details').classList.add('hidden');
                    document.getElementById('js-debit-details').classList.remove('hidden');
                  }}
                />
                <label htmlFor="payment-directDebit" className="required">
                  Direct debit
                </label>
              </li>
              <li className="form-field checkbox-item js-credit-card">
                <Field
                  id="payment-card"
                  type="radio"
                  name="paymentMethod"
                  required="required"
                  value="card"
                  onClick={(event) => {
                    document.getElementById('js-card-details').classList.remove('hidden');
                    document.getElementById('js-debit-details').classList.add('hidden');
                  }}
                />
                <label htmlFor="payment-card" className="required">
                  Credit card
                </label>
              </li>
            </ul>
          </div>
        </li>
        <li id="js-debit-details" className="form-field form-field-info card-details hidden">
          <p>
          Direct Credit: Auckland Writers & Readers Festival Charitable Trust, Account number 38-9011-0321070-00. Please include your name as a reference.
          </p>
        </li>
        <li id="js-card-details" className="form-field form-field-info card-details">
          <SimpleDonationCard />
          {/*{showAmount && <p className="note">${values.level == 'friend'*/}
          {/*  ? values.donationAmount * (values.friendsArray.length + 1)*/}
          {/*  : values.donationAmount}{' '} will be charged to your card once a year on {d.getMonth()} 1.</p>}*/}
        </li>
      </ul>
    </fieldset>
  );
};
export default DonatePaymentDetails;
